//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles } from '@material-ui/core';
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
// import Button from '@material-ui/core/Button';
import Simplebar from 'simplebar-react';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getUniqueKey } from '../../common/arrayHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import ThreadSummaryBlock from './ThreadSummaryBlock';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import _map from 'lodash/map';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            maxHeight: 510,
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props
    } = params;

    const defns = {};

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ThreadSummaries = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    const { setShowMessageDetails } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const data = _get(props, 'data', []);
    const threadSummaryOnClick = _get(props, 'threadSummaryOnClick');

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const sortedThreadSummaries = _orderBy(data, item => item.lastMessageDt, 'desc');

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Simplebar {...defns.root}>
            {_map(sortedThreadSummaries, (threadSummary, idx) => (
                <div key={`threadSummaryLi${getUniqueKey()}`} onClick={() => setShowMessageDetails(true)}>
                    <ThreadSummaryBlock data={threadSummary} onClick={threadSummaryOnClick} />
                </div>
            ))}
        </Simplebar>
    );
};

export default ThreadSummaries;
